import $ from 'jquery';

$(function(){
	
	if($('body.approach').length == 1) {
		
		var minScrollWidth = 700;
		var winWidth = false;
		var scrollBoundsTop = false;
		var scrollBoundsBottom = false;
		var positionBottom = false;
		var sectionTwoTop = false;
		var sectionThreeTop = false;
		var $headerElement = $('section.values .headings .scroller');
		var $headers = $headerElement.find('h3');
		var $sectionTwo = $('section.values .copy .section:nth-child(2)');
		var $sectionThree = $('section.values .copy .section:nth-child(3)');
		var headerPosition = 'top';
		var activeSection = 1;
		
		// reset positioning
		function resetHeaderPosition() {
			$headerElement.removeClass('middle bottom').css('top', '0');
			headerPosition = 'top';
			activeSection = 1;
		}
		
		// set positions on resize
		$(window).resize(function(){
			winWidth = $(window).width();
			resetHeaderPosition();
			if(winWidth >= minScrollWidth) {	
				scrollBoundsTop = $headerElement.offset().top;
				scrollBoundsBottom = $sectionThree.offset().top + $sectionThree.find('.h4box').position().top - ($headerElement.innerHeight() - $headerElement.height()) + 10;
				positionBottom = $sectionThree.position().top + $sectionThree.find('.h4box').position().top - ($headerElement.innerHeight() - $headerElement.height()) + 10;
				sectionTwoTop = $sectionTwo.offset().top - ($headerElement.innerHeight() - $headerElement.height());
				sectionThreeTop = $sectionThree.offset().top - ($headerElement.innerHeight() - $headerElement.height());
				$(window).trigger('scroll');
			}
		}).trigger('resize');
		
		// set state on scroll
		$(window).scroll(function(){
			requestAnimationFrame(function(){
				if(winWidth >= minScrollWidth) {
					
					var scrollTop = $(window).scrollTop();
					
					// set position
					if(scrollTop < scrollBoundsTop) {
						var newHeaderPosition = 'top';
					}
					else if(scrollTop < scrollBoundsBottom) {
						var newHeaderPosition = 'middle';
					}
					else {
						var newHeaderPosition = 'bottom';
					}
					if(newHeaderPosition != headerPosition) {
						if(newHeaderPosition == 'top') {
							resetHeaderPosition();
						}
						else if(newHeaderPosition == 'middle') {
							resetHeaderPosition();
							$headerElement.addClass('middle').css('top', '0');
						}
						else {
							resetHeaderPosition();
							$headerElement.addClass('bottom').css('top', positionBottom+'px');
						}
						headerPosition = newHeaderPosition;
					}
					
					// set active header
					if(scrollTop >= sectionThreeTop) var newActiveSection = 3;
					else if(scrollTop >= sectionTwoTop) var newActiveSection = 2;
					else newActiveSection = 1;
					if(newActiveSection != activeSection) {
						$headers.removeClass('active');
						$headers.eq(newActiveSection-1).addClass('active');
						activeSection = newActiveSection;
					}
				}
			});
		});
	}
		
});
